import { render, staticRenderFns } from "./consult-info29.vue?vue&type=template&id=2cd74f5a&scoped=true"
import script from "./consult-info29.vue?vue&type=script&lang=js"
export * from "./consult-info29.vue?vue&type=script&lang=js"
import style0 from "./consult-info29.vue?vue&type=style&index=0&id=2cd74f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd74f5a",
  null
  
)

export default component.exports